import { render, staticRenderFns } from "./view-toggle.vue?vue&type=template&id=315ec56d"
import script from "./view-toggle.vue?vue&type=script&lang=ts"
export * from "./view-toggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports